export const CheckedIcon = ({ customClassName }: { customClassName?: string }) => {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={customClassName}>
      <path d="M6.01649 11.3483L2.06487 7.45198C1.62497 7.01721 0.924137 7.01721 0.484228 7.45198C0.0443198 7.88675 0.0443198 8.57652 0.484228 9.01002L5.21482 13.6739C5.65473 14.1087 6.3669 14.1087 6.80681 13.6739L18.7738 1.88411C19.2137 1.44934 19.2137 0.759574 18.7738 0.326078C18.3339 -0.108693 17.6331 -0.108693 17.1932 0.326078L6.01649 11.3483Z" />
    </svg>
  )
}
